import React from "react";
import { Accordion } from "react-bootstrap";
import "../../../styles/pages-styles/main-dashboard-pages-styles/user-sidebar-pages/Faq.css";

const Faq = () => {
  return (
    <div className="faq-container">
      <h1>Frequently Asked Questions</h1>
      <p>If you have any questions, feel free to reach out to us.</p>

      <Accordion defaultActiveKey="0" className="mt-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            What is the purpose of this platform?
          </Accordion.Header>
          <Accordion.Body>
            This platform is designed to help users learn and practice various
            subjects.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>How can I contact support?</Accordion.Header>
          <Accordion.Body>
            You can contact support through the contact form on our website.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            What payment methods do you accept?
          </Accordion.Header>
          <Accordion.Body>
            We accept credit cards, and other popular payment methods.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>How do I extend my subscription?</Accordion.Header>
          <Accordion.Body>
            Unfortunately we don't offer shorter or longer subscription periods
            than those listed on the site.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>How do I cancel my subscription?</Accordion.Header>
          <Accordion.Body>
            You can cancel your subscription at any time through your account
            settings.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>How do I repeat questions?</Accordion.Header>
          <Accordion.Body>
            <p>There are two options for repeating questions:</p>
            <ul>
              <li>
                You can reset the history by clicking on 'More' in the top right
                hand corner of the main menu then 'Settings'. The resetting
                history option should then display. Please be aware that this
                will reset all the questions and also your performance data.
                This will only delete the history from the current resource, not
                any other resources you have on your account. By selecting this
                option you are able to do all the questions again, just as if
                you had a new account. There is no option to reset individual
                categories.
              </li>
              <li>
                You can redo the questions you've got wrong, from the 'Question
                selection' option on the main menu. If you want to simply view
                the questions and explanations then select Review Questions/key
                points. If you go to the Textbook (accessed via the Review menu
                or by pressing the button on the right hand side of the menu
                screen) you'll see all the PassMedicine background topics.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>
            What's the difference between Knowledge Tutor and Question Bank?
          </Accordion.Header>
          <Accordion.Body>
            The knowledge tutor is completely separate from the main question
            bank which supplies questions for the "Revision mode" and "Timed
            test" options. Strictly speaking the knowledge tutor isn't actually
            a question bank - it's really a list of high yield facts (for
            example "ciprofloxacin increases the risk tendinopathy"). The
            "questions" found in the knowledge tutor change on a day by day
            basis to try and constantly improve them.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="7">
          <Accordion.Header>
            How can I get involved in question writing?
          </Accordion.Header>
          <Accordion.Body>
            <p>
              We are constantly striving to improve and add to our questions
              banks. As a result we are always interested in recruiting new
              question writers for our resources.
            </p>
            <p>
              <strong>Why write for Passmedicine?</strong>
            </p>
            <ul>
              <li>
                We will pay you! Our rates are more generous than other
                publishers - we are obsessed with quality and relevance and are
                willing to pay for it.
              </li>
              <li>
                It looks great on your CV/job application. Writing
                questions/explanation not only shows your teaching ability but
                also demonstrates communication skills.
              </li>
              <li>
                We will provide all authors with a certificate they can upload
                to their portfolio.
              </li>
              <li>
                It's challenging and often fun. Once you've written the
                questions you'll be able to follow their progress in the wild
                and make changes/respond to comments if you wish.
              </li>
              <li>
                You'll be helping those trainee doctors behind you by being part
                of quality, affordable, respected resource.
              </li>
            </ul>
            <p>
              <strong>Requirements for authors:</strong>
            </p>
            <ul>
              <li>
                You have passed the exam that you are writing questions for.
              </li>
              <li>
                You can create original questions which are neither copied nor
                derived from existing publications/websites/other sources.
              </li>
              <li>You have excellent written English skills.</li>
              <li>
                You are willing to engage in a rigorous editorial process with
                our experienced editors.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Faq;
